export const siteInfo = {
  name: '久播影院',
  slogan: '高清追剧不缓冲，好剧一网打尽',
  intro: '久播影院是国内领先的电视剧在线观看平台，专注为剧迷提供最新电视剧全集免费在线观看服务。每日同步更新国产剧、韩剧、热播剧集，覆盖都市情感、古装传奇、悬疑推理、青春校园等多种题材。采用高速CDN加速与智能缓存技术，确保高清画质下流畅不缓冲的观影体验。无论您是想追完一部最新国产大剧，还是重温经典韩剧全集，久播影院都能满足您的观剧需求。',
  heroImageUrl: 'https://readdy.ai/api/search-image?query=A%20cinematic%20warm-toned%20composition%20with%20abstract%20film%20elements%2C%20soft%20golden%20and%20crimson%20light%20streaks%2C%20elegant%20geometry%2C%20dark%20theater-inspired%20atmosphere%2C%20artistic%20motion%20blur%2C%20luxurious%20texture%2C%20premium%20entertainment%20brand%20aesthetic%2C%208K%20cinematic%20quality&width=1200&height=900&seq=hero-main-2026&orientation=landscape'
};

export const heroStats = [
  { label: '每日更新剧集', value: '200+' },
  { label: '高清片源库', value: '50,000+' },
  { label: '月活观剧用户', value: '800万+' },
];

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '精彩剧集', href: '#media' },
  { label: '观众热评', href: '#comments' },
  { label: '剧集索引', href: '#index' },
  { label: '移动观影', href: '#app' },
  { label: '关于久播', href: '#about' },
];

export const topics = [
  { name: '暑期爆款剧', heat: '98万讨论', icon: 'ri-fire-line' },
  { name: '古装大女主', heat: '76万讨论', icon: 'ri-vip-crown-line' },
  { name: '韩剧天花板', heat: '65万讨论', icon: 'ri-star-line' },
  { name: '悬疑烧脑', heat: '54万讨论', icon: 'ri-search-eye-line' },
  { name: '甜宠上头', heat: '48万讨论', icon: 'ri-heart-line' },
  { name: '职场风云', heat: '41万讨论', icon: 'ri-briefcase-line' },
  { name: '年代大戏', heat: '37万讨论', icon: 'ri-history-line' },
  { name: '青春校园', heat: '33万讨论', icon: 'ri-book-open-line' },
  { name: '谍战正剧', heat: '29万讨论', icon: 'ri-shield-line' },
  { name: '家庭伦理', heat: '25万讨论', icon: 'ri-home-heart-line' },
  { name: '仙侠奇缘', heat: '22万讨论', icon: 'ri-moon-line' },
];

export const carouselItems = [
  {
    title: '《长安十二时辰》续作重磅回归',
    desc: '易烊千玺、雷佳音再度联手，大唐悬疑风暴席卷荧幕，全平台播放量首日突破3亿。',
    tag: '焦点专题',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20cityscape%20at%20sunset%20with%20warm%20golden%20light%2C%20silhouetted%20figures%20on%20rooftops%2C%20cinematic%20atmosphere%2C%20misty%20mountains%20in%20background%2C%20dramatic%20clouds%2C%20film%20poster%20style%2C%20rich%20amber%20and%20crimson%20tones&width=800&height=500&seq=carousel-01&orientation=landscape'
  },
  {
    title: 'S级韩剧《月之酒店》导演新作',
    desc: 'IU、朴宝剑领衔主演，奇幻爱情题材新标杆，韩国收视率连续八周冠军。',
    tag: '韩剧精选',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20aesthetic%20scene%20with%20cherry%20blossoms%2C%20soft%20golden%20hour%20lighting%2C%20elegant%20couple%20silhouette%20against%20warm%20sunset%2C%20dreamy%20atmosphere%2C%8Cinematic%20composition%2C%20pastel%20and%20warm%20tones&width=800&height=500&seq=carousel-02&orientation=landscape'
  },
  {
    title: '国产悬疑剧天花板《白夜追凶2》',
    desc: '潘粤明一人分饰两角，硬核推理回归，年度最期待国产剧没有之一。',
    tag: '国产力作',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20urban%20night%20scene%20with%20rain-soaked%20streets%2C%20neon%20reflections%2C%20silhouetted%20detective%20figure%2C%20film%20noir%20aesthetic%2C%20deep%20shadows%20and%20contrast%2C%20suspenseful%20atmosphere%2C%20cinematic%20lighting&width=800&height=500&seq=carousel-03&orientation=landscape'
  },
  {
    title: '年代情感大剧《人世间》姊妹篇',
    desc: '梁晓声原著改编，雷佳音、殷桃再度携手，讲述改革开放浪潮中的家庭史诗。',
    tag: '年代经典',
    image: 'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20Chinese%20family%20scene%20from%201980s%2C%20vintage%20furniture%20and%20warm%20indoor%20lighting%2C%20family%20gathering%20atmosphere%2C%20soft%20sepia%20tones%2C%20sentimental%20mood%2C%20old%20photographs%20aesthetic%2C%20cinematic%20composition&width=800&height=500&seq=carousel-04&orientation=landscape'
  },
];

export const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速不缓冲',
    desc: '智能CDN加速+自适应码率，4K超清也能秒加载，告别转圈等待',
  },
  {
    icon: 'ri-hd-line',
    title: '真高清画质',
    desc: '1080P起步、4K可选，HDR加持，连微表情都纤毫毕现',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '日更同步追',
    desc: '与卫视同步更新，热门剧集上线24小时内即可免费观看全集',
  },
  {
    icon: 'ri-device-line',
    title: '全端无缝看',
    desc: '手机、平板、电脑、电视四端同步，进度云记忆，随时随地接着看',
  },
];

export const updates = [
  { time: '15分钟前', content: '《玫瑰的故事》第28集上线，刘亦菲演技炸裂引爆热议', tag: '热播' },
  { time: '42分钟前', content: '《庆余年3》官宣开机，张若昀确认回归原班人马', tag: '重磅' },
  { time: '1小时前', content: '韩剧《现在拨打的电话》全集更新完毕，悬疑爱情双双在线', tag: '完结' },
  { time: '2小时前', content: '《大奉打更人》预约人数突破500万，古装探案题材持续走热', tag: '热门' },
  { time: '3小时前', content: '暑期档国产剧片单公布，15部大剧扎堆上线谁将成黑马', tag: '资讯' },
  { time: '5小时前', content: '《我的阿勒泰》豆瓣开分8.7，自然治愈风获年度口碑最高', tag: '好评' },
  { time: '7小时前', content: '《承欢记》杨紫许凯CP感拉满，都市情感剧收视破2', tag: '热播' },
  { time: '9小时前', content: '《与凤行》海外版权热销，国产仙侠剧出海再创佳绩', tag: '出海' },
];

export const rankingItems = [
  { rank: 1, title: '玫瑰的故事', heat: '热度 9867', trend: 'up', category: '都市情感' },
  { rank: 2, title: '庆余年 第二季', heat: '热度 9521', trend: 'up', category: '古装传奇' },
  { rank: 3, title: '现在拨打的电话', heat: '热度 9188', trend: 'new', category: '韩剧悬疑' },
  { rank: 4, title: '我的阿勒泰', heat: '热度 8754', trend: 'up', category: '治愈田园' },
  { rank: 5, title: '大奉打更人', heat: '热度 8321', trend: 'up', category: '古装探案' },
];

export const contactInfo = {
  title: '剧迷投稿 & 合作咨询',
  desc: '发现好剧想推荐？片源合作、广告投放、Copyright咨询，欢迎通过以下方式联系久播影院运营团队。我们珍视每一位剧迷的声音，共同打造更优质的观剧平台。',
  email: 'contact@jiubotv.com',
  wechat: '久播影院官方',
};

export const faqItems = [
  {
    q: '久播影院真的可以免费在线观看所有电视剧吗？',
    a: '是的，久播影院所有电视剧全集均免费在线观看，无需注册登录，无需VIP会员。我们通过广告合作和品牌赞助维持运营，持续为剧迷提供高清不缓冲的观影服务。',
  },
  {
    q: '为什么有些剧集播放很流畅，画质还特别清晰？',
    a: '久播影院采用先进的智能CDN分发和自适应码率技术，根据您的网络状况自动匹配最佳画质。同时片源均采用H.265高效编码，在保证高清画质的同时大幅降低带宽需求，实现真高清不缓冲。',
  },
  {
    q: '最新电视剧上线后多久可以在久播影院看到？',
    a: '大部分热门国产剧和韩剧在电视台或流媒体平台播出后24小时内，久播影院即完成片源处理和上线。部分VIP抢先看剧集可能稍有延迟，但全集更新速度在同类平台中始终领先。',
  },
  {
    q: '久播影院支持哪些设备观看？可以投屏吗？',
    a: '久播影院全面适配手机、平板、电脑和智能电视，支持AirPlay和DLNA投屏协议。同一个账号的观看历史和收藏会自动同步到所有设备，换设备也能无缝接续上次的观剧进度。',
  },
];

export const cardItems = [
  {
    title: '都市情感剧推荐：那些年我们追过的爱情故事',
    desc: '从《玫瑰的故事》到《承欢记》，都市情感剧始终是国产剧的流量担当，这里有最全的都市情感剧片单。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20romantic%20city%20night%20scene%20with%20soft%20bokeh%20lights%2C%20couple%20walking%20on%20urban%20street%2C%20modern%20Chinese%20drama%20aesthetic%2C%20gentle%20warm%20color%20palette%2C%20cinematic%20mood%2C%20elegant%20composition&width=600&height=400&seq=card-01&orientation=landscape'
  },
  {
    title: '古装传奇大剧大盘点：服化道巅峰之作都在这里',
    desc: '《庆余年》《长安十二时辰》《与凤行》……古装剧的制作水准逐年攀升，服化道越来越考究。',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ancient%20palace%20interior%20with%20warm%20lantern%20light%2C%20elegant%20silk%20fabrics%2C%20ornate%20wooden%20carvings%2C%20soft%20golden%20ambient%20light%2C%20historical%20drama%20set%20design%2C%20cinematic%20rich%20textures&width=600&height=400&seq=card-02&orientation=landscape'
  },
  {
    title: '2024韩剧必看清单：从悬疑到甜宠一网打尽',
    desc: '今年韩剧质量大爆发，悬疑、爱情、奇幻题材均有现象级作品，久播为你精选不可错过的韩剧全集。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20drama%20aesthetic%20with%20cozy%20cafe%20scene%2C%20warm%20interior%20lighting%2C%20books%20and%20coffee%2C%20soft%20romantic%20atmosphere%2C%20elegant%20minimal%20design%2C%20gentle%20pastel%20and%20warm%20tones&width=600&height=400&seq=card-03&orientation=landscape'
  },
  {
    title: '悬疑推理剧迷福音：烧脑神作合集不容错过',
    desc: '从《白夜追凶》到《隐秘的角落》，国产悬疑剧正在经历黄金时代，烧脑程度不输英美剧。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20room%20with%20dramatic%20light%20shafts%2C%20detective%20board%20with%20clues%20and%20red%20threads%2C%20film%20noir%20aesthetic%2C%20deep%20shadows%2C%20suspenseful%20atmosphere%2C%20cinematic%20lighting%20with%20warm%20accents&width=600&height=400&seq=card-04&orientation=landscape'
  },
  {
    title: '暑期档追剧指南：15部大剧上线哪部是你的菜',
    desc: '每年暑期档都是剧集市场的兵家必争之地，今年更是神仙打架，我们帮你梳理出最值得追的片单。',
    image: 'https://readdy.ai/api/search-image?query=Bright%20summer%20living%20room%20with%20large%20TV%20screen%2C%20comfortable%20sofa%2C%20popcorn%20and%20drinks%2C%20warm%20sunlight%20streaming%20through%20windows%2C%20cozy%20home%20theater%20atmosphere%2C%20relaxed%20entertainment%20vibe&width=600&height=400&seq=card-05&orientation=landscape'
  },
  {
    title: '年代剧的厚重与温情：那些值得细品的经典之作',
    desc: '《人世间》《山海情》《大江大河》……年代剧用细腻笔触描绘时代变迁中普通人的命运沉浮。',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20countryside%20scene%20at%20golden%20hour%2C%20old%20brick%20houses%2C%20warm%20sunset%20light%2C%20vintage%20aesthetic%2C%20sentimental%20mood%2C%20peaceful%20rural%20atmosphere%2C%20cinematic%20warm%20sepia%20tones&width=600&height=400&seq=card-06&orientation=landscape'
  },
];

export const comments = [
  {
    name: '剧迷小圆子',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20young%20Chinese%20woman%20portrait%20with%20warm%20smile%2C%20clean%20simple%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style%2C%20warm%20neutral%20tones&width=80&height=80&seq=avatar-01&orientation=squarish',
    time: '2小时前',
    content: '用了久播影院大半年了，画质和流畅度真的没话说！之前用其他平台看韩剧总是卡，这边4K都秒开，太惊喜了。而且片源更新速度确实快，《玫瑰的故事》昨天电视刚播完，今天全集就有了。',
  },
  {
    name: '追剧小达人阿飞',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20young%20Chinese%20man%20portrait%20with%20gentle%20smile%2C%20clean%20simple%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style%2C%20warm%20neutral%20tones&width=80&height=80&seq=avatar-02&orientation=squarish',
    time: '5小时前',
    content: '作为一个资深悬疑剧迷，久播的片库真的太全了！《白夜追凶》《隐秘的角落》《沉默的真相》这些国悬天花板都有，还有冷门佳作推荐，简直是悬疑党的宝藏平台。',
  },
  {
    name: '韩剧十级学者',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20smiling%20young%20Asian%20woman%20portrait%2C%20clean%20simple%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style%2C%20warm%20neutral%20tones&width=80&height=80&seq=avatar-03&orientation=squarish',
    time: '昨天',
    content: '韩剧这块久播做得特别好！翻译准确率高，字幕同步到位，而且全集更新速度不比韩国本土慢。《现在拨打的电话》我就是在久播追完的，体验满分。',
  },
  {
    name: '古风控小江',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20young%20Chinese%20man%20portrait%20with%20casual%20smile%2C%20clean%20simple%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style%2C%20warm%20neutral%20tones&width=80&height=80&seq=avatar-04&orientation=squarish',
    time: '昨天',
    content: '古装剧爱好者狂喜！《庆余年2》《与凤行》《长相思》都是我在久播追完的。分类特别细，按朝代、题材都能搜，找剧超方便。画质清晰到能数清楚龙袍上的纹样！',
  },
];

export const appEntry = {
  title: '久播影院 · 移动端',
  desc: '扫码下载久播影院App，手机追剧更便捷。支持离线缓存、夜间模式、倍速播放，通勤路上也能畅享高清剧集。',
  features: ['离线缓存追剧', '智能夜间模式', '0.5x-3x倍速', '弹幕互动'],
  qrImage: 'https://readdy.ai/api/search-image?query=A%20minimalist%20modern%20QR%20code%20design%20with%20cinematic%20elements%2C%20clean%20black%20and%20white%2C%20subtle%20film%20reel%20pattern%20border%2C%20elegant%20design%2C%20high%20contrast&width=400&height=400&seq=qr-app&orientation=squarish',
  previewImage: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20movie%20streaming%20app%20interface%20with%20drama%20posters%2C%20clean%20dark%20UI%2C%20elegant%20design%2C%20soft%20lighting%2C%20product%20photography%20style%2C%20warm%20ambient%20light&width=600&height=800&seq=app-preview&orientation=portrait'
};

export const indexItems = [
  { title: '国产剧', count: '12,800+部', icon: 'ri-china-railway-line' },
  { title: '韩剧', count: '3,600+部', icon: 'ri-earth-line' },
  { title: '悬疑推理', count: '2,150+部', icon: 'ri-search-eye-line' },
  { title: '都市情感', count: '5,420+部', icon: 'ri-heart-pulse-line' },
  { title: '古装传奇', count: '4,380+部', icon: 'ri-empathize-line' },
  { title: '青春校园', count: '1,860+部', icon: 'ri-book-open-line' },
  { title: '年代大戏', count: '980+部', icon: 'ri-history-line' },
  { title: '仙侠奇幻', count: '1,540+部', icon: 'ri-moon-foggy-line' },
  { title: '全部剧集', count: '50,000+', icon: 'ri-film-line' },
];

export const mediaItems = [
  {
    title: '玫瑰的故事',
    desc: '都市情感 · 刘亦菲 佟大为 领衔主演',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20Chinese%20woman%20in%20a%20rose%20garden%20at%20golden%20hour%2C%20soft%20romantic%20atmosphere%2C%20cinematic%20lighting%2C%20warm%20pink%20and%20golden%20tones%2C%20beautiful%20composition%2C%20film%20poster%20aesthetic&width=600&height=400&seq=media-01&orientation=landscape'
  },
  {
    title: '庆余年 第二季',
    desc: '古装传奇 · 张若昀 李沁 陈道明',
    image: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20palace%20scene%20with%20dramatic%20clouds%2C%20silhouetted%20figure%20in%20traditional%20robes%2C%20golden%20sunset%20light%2C%20powerful%20composition%2C%20cinematic%20scale%2C%20warm%20amber%20and%20crimson%20tones&width=600&height=400&seq=media-02&orientation=landscape'
  },
  {
    title: '现在拨打的电话',
    desc: '韩剧悬疑爱情 · 柳演锡 蔡秀彬',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20phone%20booth%20in%20rainy%20Korean%20city%20night%2C%20neon%20reflections%2C%20dramatic%20lighting%2C%20romantic%20suspense%20atmosphere%2C%20Korean%20drama%20aesthetic%2C%20cinematic%20mood%20with%20warm%20accents&width=600&height=400&seq=media-03&orientation=landscape'
  },
  {
    title: '我的阿勒泰',
    desc: '治愈田园 · 马伊琍 周依然 于适',
    image: 'https://readdy.ai/api/search-image?query=Vast%20beautiful%20grassland%20landscape%20at%20golden%20hour%2C%20rolling%20hills%2C%20warm%20sunset%20light%2C%20peaceful%20pastoral%20scene%2C%20cinematic%20wide%20shot%2C%20healing%20natural%20atmosphere%2C%20warm%20earthy%20tones&width=600&height=400&seq=media-04&orientation=landscape'
  },
  {
    title: '大奉打更人',
    desc: '古装探案 · 王鹤棣 田曦薇 领衔',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20night%20watchman%20in%20misty%20alley%20with%20lantern%20light%2C%20mysterious%20atmosphere%2C%20traditional%20architecture%2C%20dramatic%20shadows%2C%20warm%20glowing%20lanterns%2C%20cinematic%20noir%20style&width=600&height=400&seq=media-05&orientation=landscape'
  },
];

export const aboutInfo = {
  title: '关于久播影院',
  paragraphs: [
    '久播影院创立于2020年，是国内领先的高清电视剧在线观看平台，致力于为全球华语观众提供最新电视剧全集免费在线观看服务。平台覆盖国产剧、韩剧、港剧、台剧、美剧等多语种剧集，片源总数超过50,000部，涵盖都市情感、古装传奇、悬疑推理、青春校园、年代大戏、仙侠奇幻等全品类题材。',
    '我们始终坚持"高清不缓冲"的核心体验理念，自建智能CDN分发网络，采用H.265高效视频编码技术，在保证震撼画质的同时大幅降低带宽消耗，让每一位观众都能享受秒开流畅的观剧体验。日更机制确保热播剧集上线24小时内即可免费观看全集，同步追剧零时差。',
    '久播影院的成长离不开每一位剧迷的支持与信任。我们将持续优化产品体验，扩充片源库，为华语观众打造最优质的一站式追剧平台。',
  ],
};

export const footerLinks = [
  {
    title: '剧集分类',
    links: [
      { label: '国产剧', href: '#index' },
      { label: '韩剧全集', href: '#index' },
      { label: '悬疑推理', href: '#index' },
      { label: '古装传奇', href: '#index' },
    ],
  },
  {
    title: '快速导航',
    links: [
      { label: '精彩剧集', href: '#media' },
      { label: '热度榜单', href: '#ranking' },
      { label: '常见问答', href: '#faq' },
      { label: '剧迷投稿', href: '#contact' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '关于久播', href: '#about' },
      { label: '移动观影', href: '#app' },
      { label: '观众热评', href: '#comments' },
      { label: '剧集索引', href: '#index' },
    ],
  },
  {
    title: '合作伙伴',
    links: [],
  },
];